export const cmdbAsyncActionsResultsEntrypointModalProps = { width: 'large' };
